// kode-promo.js


async function fetchAllVouchers() {
  try {
    const accessToken = localStorage.getItem("member_access_token") || "";
    const response = await fetch(
      "https://dev-shop-api.daninaportal.id/v1/loyalty/vouchers?cat=" +
      encodeURIComponent(accessToken),
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    console.log("Fetched voucher data:", data);
    return data;
  } catch (error) {
    console.log("Error fetching voucher data: " + error);
    return null;
  }
}

async function copyContent(text) {
  try {
    await navigator.clipboard.writeText(text);
    console.log("Voucher copied to clipboard" + text);
    $("#popupHasilTukarPoint").modal("hide");
    $("#popupHasilSalin").modal("show");
  } catch (err) {
    console.error("Failed to copy: ", err);
  }
}

async function copyContentPromo(text) {
  try {
    await navigator.clipboard.writeText(text);
    console.log("Voucher copied to clipboard" + text);
    $("#popupHasilSalin .modal-description").html(
      "Selamat! Kode promo sudah berhasil disalin. Checkout sekarang untuk mendapatkan promo spesial!"
    );
    $("#popupHasilSalin").modal("show");
  } catch (err) {
    console.error("Failed to copy: ", err);
  }
}

async function copyContentHome(text) {
  try {
    await navigator.clipboard.writeText(text);
    console.log("Voucher copied to clipboard" + text);
    alert("Kode promo sudah berhasil disalin " + text);
  } catch (err) {
    console.error("Failed to copy: ", err);
  }
}

function getVoucherType(typeCode) {
  let voucherType = "";

  if (
    typeCode == "DiscountFixedAmount" ||
    typeCode == "DiscountPercentage" ||
    typeCode == "DiscountAutomaticBasic"
  ) {
    voucherType = "Diskon Produk";
  } else if (typeCode == "BxGy") {
    voucherType = "Buy X Get Y";
  } else if (typeCode == "FreeShipping") {
    voucherType = "Gratis Ongkir";
  }

  return voucherType;
}

function prepRedeemVoucher(point, voucherName) {
  $("#popupTukarPoint .modal-description").html(
    'Apa mama yakin akan menukarkan <br><span style="color:#1E3D7D;">' +
    point +
    " point</span> untuk mendapatkan " +
    voucherName +
    "?</span>"
  );
  $("#popupTukarPoint #redeemBtn").attr(
    "onclick",
    "redeemVoucher('" + voucherName + "')"
  );
  $("#popupHasilSalin .modal-description").html(
    'Selamat! Kode promo <span style="font-weight:700">' +
    point +
    " point Nutriclub</span> sudah berhasil disalin. Checkout sekarang untuk mendapatkan promo spesial!"
  );
}

function redeemVoucher(voucherName) {
  showLoader();
  $("#popupTukarPoint").modal("hide");

  $.ajax({
    url: "https://dev-shop-api.daninaportal.id/v1/loyalty/vouchers",
    type: "POST",
    contentType: "application/json",
    data: JSON.stringify({
      cat: localStorage.getItem("member_access_token") || "",
      voucherCode: voucherName,
    }),
    success: function (response) {
      $("#popupTukarPoint").modal("hide");

      if (!response.status.success) {
        $("#popupHasilTukarPoint .modal-title").addClass("failed");
        if (response.status.code == "25") {
          $("#popupHasilTukarPoint .modal-title.failed").text(
            "Penukaran point Nutriclub Gagal!"
          );
          $("#popupHasilTukarPoint .modal-description").text(
            "Ups, poin Nutriclub belum cukup. Terus kumpulkan poin Nutriclub untuk dapatkan promo ini"
          );
        } else {
          $("#popupHasilTukarPoint .modal-title").text(
            "Penukaran point Nutriclub Gagal!"
          );
          $("#popupHasilTukarPoint .modal-description").text(
            response.status.message.id
          );
        }

        $("#popupHasilTukarPoint .content_copy_voucher").remove();
      } else {
        $("#popupHasilTukarPoint .modal-title").removeClass("failed");
        $("#popupHasilTukarPoint .modal-title").text(
          "Tukar Nutriclub Point Berhasil!"
        );
        $("#popupHasilTukarPoint .modal-description").text(
          "Silahkan salin kode voucher dan gunakan pada saat checkout"
        );

        let voucherCode = response.data.voucherCode;
        let buttonToInsert =
          '<div class="search-modal__content content_copy_voucher" tabindex="-1">';
        buttonToInsert +=
          '<button id="copyCodeBtn" onclick="copyContent(\'' +
          voucherCode +
          "')\">Salin Kode Voucher Di Sini</button>";
        buttonToInsert += "</div>";

        $(buttonToInsert).insertAfter($("#popupHasilTukarPoint .modal-header"));
      }

      hideLoader();
      $("#popupHasilTukarPoint").modal("show");
    },
    error: function (xhr, status, error) {
      hideLoader();

      $("#popupHasilTukarPoint .modal-title").text(
        "Penukaran point Nutriclub Gagal!"
      );
      $("#popupHasilTukarPoint .modal-description").text(
        "Silahkan dicoba kembali"
      );
      $("#popupHasilTukarPoint .content_copy_voucher").remove();
      $("#popupHasilTukarPoint").modal("show");
      console.error("Error:", error); // Handle error response
    },
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll(
    '.custom-banner-section .banner-item img'
  ).forEach(img => {
    img.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      var destinationUrl = this.closest('a')?.getAttribute('href') || null;
      var currentUrl = window.location.href;

      if (typeof smartech !== "undefined") {
        smartech('dispatch', 'homepage_banner_nutrishop', {
          banner_name: destinationUrl || '(no link)',
          position: currentUrl
        });
      }

      if (destinationUrl) {
        setTimeout(function () {
          window.location.href = destinationUrl;
        }, 300);
      }
    }, true);
  });
});

document.querySelectorAll('#redirectNutriclub img').forEach(img => {
  img.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    if (typeof smartech !== "undefined") {
      smartech('dispatch', 'click_daftar_nutrishop', {
        button_name: 'Join Nutriclub',
        position: 'Nutrishop Homepage'
      });
    }

    if (typeof ssoNutriclub === "function") {
      ssoNutriclub();
    }
  });
});

document.querySelectorAll(".product-home .pf-main-media, .product-home .pf-heading-1-h3")
  .forEach(el => {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      console.log("test");

      let href = el.dataset.href;
      if (!href) return;

      let form = this.closest("form");
      let itemId = form?.getAttribute("data-productid") || "";
      let itemName = form?.querySelector("h3")?.innerText || "";
      let priceString = form?.querySelector("div[data-product-type='price']")?.innerText || "";
      let compareAt = form?.querySelector("div[data-product-type='compare_at_price']")?.innerText || "";
      let oriPrice = compareAt ? (priceToNumber(compareAt) - priceToNumber(priceString)) : 0;

      let category = itemName.includes("Nutribaby") ? "Nutribaby" : "Nutrilon Royal";
      let category2 = itemName.includes("Royal 1") ? "Nutribaby Royal 1" :
        itemName.includes("Royal 2") ? "Nutribaby Royal 2" :
          itemName.includes("Royal 3") ? "Nutrilon Royal 3" :
            itemName.includes("Royal 4") ? "Nutrilon Royal 4" : "Nutribaby Cesabio";

      let category3 = itemName.includes("Royal 1") ? "0-6 Bulan" :
        itemName.includes("Royal 2") ? "6-12 Bulan" :
          itemName.includes("Royal 3") ? "1-3 Tahun" :
            itemName.includes("Royal 4") ? "3-6 Tahun" : "0-6 Bulan";

      let category5 = oriPrice === 0 ? "No" : "Yes";

      if (typeof smartech !== "undefined") {
        smartech('dispatch', 'select_item', {
          item_list_id: 'nutrishop_homepage_pilihan_eksklusif',
          item_list_name: 'Nutrishop Homepage Pilihan Eksklusif',
          items: [
            {
              'item_id': itemId,
              'item_name': itemName,
              'price': priceToNumber(priceString),
              'discount': oriPrice,
              'quantity': '1',
              'item_brand': 'Nutrilon',
              'item_category': category,
              'item_category2': category2,
              'item_category3': category3,
              'item_category5': category5,
              'item_variant': 'Purchase'
            }
          ]
        });

        smartech('dispatch', 'click_highlight_products_homepage', {
          button_name: itemName,
          position: 'pilihan ekslusif untuk mama',
        });
      }
      setTimeout(function () {
        window.location.href = href;
      }, 300);
    }, true);
  });

document.querySelectorAll(".collection-list-wrapper img[data-href], .collection-list-wrapper h3.pf-heading-1-h3 a").forEach(el => {
  el.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    let href = el.getAttribute("data-href") || el.getAttribute("href") || "";
    let itemName = el.closest("h3")?.innerText.trim() || el.getAttribute("alt") || "";

    let collectionStage = "";
    if (itemName.includes("0-6")) collectionStage = "collection_IF";
    else if (itemName.includes("0-12")) collectionStage = "collection_FO";
    else if (itemName.includes("Royal 3")) collectionStage = "collection_GUM1";
    else if (itemName.includes("Royal 4")) collectionStage = "collection_GUM3";

    if (typeof smartech !== "undefined" && collectionStage) {
      smartech('dispatch', 'click_collections', {
        "button name": collectionStage,
        position: 'nutrishop homepage',
      });
    }
    setTimeout(() => { window.location.href = href; }, 300);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Cek kalau ini homepage
  if (window.location.pathname === "/" || window.location.pathname === "/index.html") {

    let idleTimer;
    let idleTime = 30000; // 30 detik

    function resetTimer() {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(sendIdleEvent, idleTime);
    }

    function sendIdleEvent() {
      if (typeof smartech !== "undefined") {
        smartech('dispatch', 'homepage_iddle', {
          page: 'nutrishop_homepage',
          timestamp: new Date().toISOString()
        });
        console.log("Smartech Event Sent: homepage_iddle");
      } else {
        console.warn("Smartech not loaded");
      }
    }

    // Reset timer jika ada interaksi
    ['mousemove', 'scroll', 'click', 'keydown', 'touchstart'].forEach(evt => {
      window.addEventListener(evt, resetTimer, false);
    });

    // Mulai hitung waktu idle pertama kali
    resetTimer();
  }
});
